module.exports = __webpack_public_path__ + "static/media/washing-machine.9966d6c0.svg";